import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-batch-update',
    templateUrl: './batch-update.component.html',
    styleUrls: ['./batch-update.component.css'],
    standalone: false
})
export class BatchUpdateComponent {

  constructor(
    public saveSeasonDetailsDialog: MatDialogRef<BatchUpdateComponent>,
  ) {
  }
  
    cancel(): void {
      this.saveSeasonDetailsDialog.close({"option": "cancel"});
    }
  
    save(): void {
      this.saveSeasonDetailsDialog.close({"option": "save"});
    }
  }
